import * as path from "node:path";
import { buildCustomTypeDirectoryPath } from "./buildCustomTypeDirectoryPath.js";
const buildCustomTypeFilePath = (args) => {
  return path.join(buildCustomTypeDirectoryPath(args), args.filename);
};
export {
  buildCustomTypeFilePath
};
//# sourceMappingURL=buildCustomTypeFilePath.js.map
